const frame = {
  state: {
    appStatus: {
      currentPage: "/",
      previousPage: "/"
    },
    snackbarInfo: {
      enable: false,
      text: ""
    },
    btnSpinEnabled: true,
    // searchError: true,
    currentPage: "/welcomeview",
    previousPage: ""
  },
  mutations: {
    changeAppStatus(state, payload) {
      state.appStatus = payload;
    },
    changeSnackbarInfo(state, payload) {
      state.snackbarInfo = payload;
    },
    enableBtnSpin(state, payload) {
      state.btnSpinEnabled = payload;
    },
    changeCurrentPage(state, payload) {
      state.currentPage = payload;
    },
    changePreviousPage(state, payload) {
      state.previousPage = payload;
    },
    changeQueryList(state, payload) {
      state.queryList = payload;
    }
  },
  actions: {
    changeAppStatus({ commit }, payload) {
      commit("changeAppStatus", payload);
    },
    changeSnackbarInfo({ commit }, payload) {
      commit("changeSnackbarInfo", payload);
    },
    enableBtnSpin({ commit }, payload) {
      commit("enableBtnSpin", payload);
    },
    changeCurrentPage({ commit }, payload) {
      commit("changeCurrentPage", payload);
    },
    changePreviousPage({ commit }, payload) {
      commit("changePreviousPage", payload);
    }
  },
  getters: {
    getSnackbarInfo: state => {
      return state.snackbarInfo;
    },
    getBtnSpinEnabled: state => {
      return state.btnSpinEnabled;
    },
    getAppStatus: state => {
      return state.appStatus;
    },
    getCurrentPage: state => {
      return state.currentPage;
    },
    getPreviousPage: state => {
      return state.previousPage;
    }
  }
};
export default frame;
